<div class="base-template-wrapper">
    <header class="header">
        <div class="row pt-2">
            <div class="col-3">
                <div class="d-flex">
                    <div class="mx-3 py-2 mt-1" >
                        <button
                        class="btn btn-light btn-sm pb-0"
                        (click)="toggleNavigation()"
                        >
                            <ng-icon
                            [@iconRotate]="isNavigationOpen ? 'open' : 'closed'"
                            class=""
                            size="2em"
                            [name]="isNavigationOpen ? 'bootstrapX' : 'bootstrapList'"
                            ></ng-icon>
                        </button>

                    </div>
                    <div class="logo-container mt-2">
                        <a
                            class="py-2"
                            href="https://www.trifectatms.com"
                            target="_blank"
                        >
                            <app-branding-logo-display [useDefaultLogo]="true"></app-branding-logo-display>
                        </a>
                    </div>
                </div>
            </div>
            <div class="offset-7 col-2">
                <div class="d-flex float-end py-2 mt-1">
                    <div class="mx-3">
                        <button class="btn btn-light btn-sm" (click)="openConfiguration()">
                            <ng-icon size="2em" name="bootstrapGear"></ng-icon>
                        </button>
                    </div>
                    <div>
                        <button class="btn btn-light btn-sm" (click)="logout()">
                            <ng-icon size="2em" name="bootstrapDoorOpen"></ng-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <div class="body-wrapper">
            <div [@drawerSlide]="isNavigationOpen ? 'open' : 'closed'" class="navigation-wrapper border-end">
                <app-navigation #sidebar [navigationItems]="navigationItems$ | async" [userConfig]="userConfig$ | async"></app-navigation>
            </div>

        <div class="main-wrapper bg-light" >
            <div  [ngClass]="!isNavigationOpen ? 'full' : 'shrink'" class="content-wrapper rounded shadow">
                <router-outlet name="dashboard"></router-outlet>
            </div>
        </div>
    </div>
</div>
